import dateFormatType from '@/constants/dateFormatType';
import { currency, validateTextWithHypen, } from '@/utils';
import { format } from 'date-fns';
export class WorkerProfitDetail {
    _workerProfitDetail;
    constructor(workerProfitByWorkerCode) {
        this._workerProfitDetail = workerProfitByWorkerCode;
    }
    /** 일시 */
    get formattedCreatedAt() {
        const createdAt = format(new Date(this._workerProfitDetail.createdAt), dateFormatType.FULL_DATE);
        return validateTextWithHypen(createdAt);
    }
    /** 항목 */
    get formattedWorkerBaromoneyTypeDetail() {
        const { workerBaromoneyTypeDetail } = this._workerProfitDetail;
        return validateTextWithHypen(workerBaromoneyTypeDetail);
    }
    /** 금액 */
    get formattedTransactionBaromoney() {
        const { transactionBaromoney } = this._workerProfitDetail;
        return currency(transactionBaromoney);
    }
    /** 라이더 바로머니 잔액 */
    get formattedBalanceBaromoney() {
        const { balanceBaromoney } = this._workerProfitDetail;
        return currency(balanceBaromoney);
    }
    /** 메모 */
    get formattedWorkerBaromoneyMemo() {
        const { workerBaromoneyMemo } = this._workerProfitDetail;
        return validateTextWithHypen(workerBaromoneyMemo);
    }
    /** 접수번호 */
    get formattedOrderId() {
        const { orderId } = this._workerProfitDetail;
        return validateTextWithHypen(orderId);
    }
    /** 처리자 */
    get formattedCreatedBy() {
        const { createdBy } = this._workerProfitDetail;
        return validateTextWithHypen(createdBy);
    }
}
